'use client';

import styled from 'styled-components';

import Chevron from '@icons/Chevron.svg';

export const StyledChevron = styled(Chevron)`
  transform: rotate(-180deg);
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
`;
